export default __webpack_public_path__ + "static/media/attendance.3b316f26.svg";